import html from "./VisualConsentStep.html"

var module = angular.module("ResearchKitApplicationModule");

module.directive("visualConsentStep",
	function () {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			}
		};
	}
);

module.controller("visualConsentStepController", ["$scope", "$sce",
	function ($scope, $sce) {
		$scope.$watch('stepManager.surveyManager.template.consentDocuments', function () { $scope.stepManager.refreshView(); }, true);
		$scope.$watch('stepManager.step', function () { $scope.stepManager.refreshView(); }, true);
		$scope.$watch('stepManager.visualConsentStepIndex', function (newValue) {
			$scope.stepManager.refreshView();
			if ($scope.stepManager.currentVisualConsentSection) {
				$scope.stepManager.surveyManager.trackSubStepViewed($scope.stepManager.step.identifier, $scope.stepManager.currentVisualConsentSection.title, newValue);
			}
		});

		$scope.$on('nextStackStep', function () {
			if ($scope.stepManager.visualConsentStepIndex == $scope.stepManager.totalVisualConsentSteps - 1) {
				$scope.stepManager.visualConsentStepIndex = 0;
			} else {
				$scope.stepManager.visualConsentStepIndex++;
			}
		});

		$scope.$on('previousStackStep', function () {
			if ($scope.stepManager.visualConsentStepIndex == 0) {
				$scope.stepManager.visualConsentStepIndex = $scope.stepManager.totalVisualConsentSteps - 1;
			} else {
				$scope.stepManager.visualConsentStepIndex--;
			}
		});

		$scope.trustAsHtml = function (value) { return $sce.trustAsHtml(value); };
		$scope.learnMore = {
			show: false
		};
	}
]);


module.factory("VisualConsentStepManager", ["StepManager", "ceUrl", "$sanitize", function (StepManager, ceUrl, $sanitize) {
	function VisualConsentStepManager(step, surveyManager) {
		StepManager.call(this, step, surveyManager);
		this.visualConsentStepIndex = 0;
	}
	VisualConsentStepManager.prototype = Object.create(StepManager.prototype);

	VisualConsentStepManager.prototype.initializeResults = function (previousResult, navigatingForwards) {
		StepManager.prototype.initializeResults.call(this, previousResult, navigatingForwards);
		if (!navigatingForwards) {
			this.visualConsentStepIndex = this.getVisualConsentSections().length - 1;
		}
	}

	VisualConsentStepManager.prototype.back = function () {
		if (this.visualConsentStepIndex == 0) {
			StepManager.prototype.back.call(this);
		} else {
			this.visualConsentStepIndex--;
		}
	}

	VisualConsentStepManager.prototype.consentDocument = function () {
		var step = this.step;
		return _.find(this.surveyManager.template.consentDocuments, function (document) { return document.title == step.consentDocumentTitle });
	}

	VisualConsentStepManager.prototype.continue = function () {
		if (this.visualConsentStepIndex == this.getVisualConsentSections().length - 1) {
			StepManager.prototype.continue.call(this);
		} else {
			this.visualConsentStepIndex++;
		}
	}

	VisualConsentStepManager.prototype.getVisualConsentSections = function () {
		var sections = [];
		var consentDocument = this.consentDocument();

		if (consentDocument && consentDocument.sections) {
			for (var i = 0; i < consentDocument.sections.length; i++) {
				if (consentDocument.sections[i].sectionType != 'OnlyInDocument') {
					sections.push(consentDocument.sections[i]);
				}
			}
		}
		return sections;
	}

	VisualConsentStepManager.prototype.refreshView = function () {
		var sections = this.getVisualConsentSections();
		this.totalVisualConsentSteps = sections.length;
		this.currentVisualConsentSection = sections[this.visualConsentStepIndex];
	}

	VisualConsentStepManager.prototype.getLearnMoreText = function () {
		if (!this.currentVisualConsentSection) { return; }

		switch (this.currentVisualConsentSection.sectionType) {
			case "Overview":
				return "Learn more about the study first";
			case "DataGathering":
				return "Learn more about how data is gathered";
			case "Privacy":
				return "Learn more about how your privacy and identity are protected";
			case "DataUse":
				return "Learn more about how data is used";
			case "TimeCommitment":
				return "Learn more about the study's impact on your time";
			case "StudySurvey":
				return "Learn more about the study survey";
			case "StudyTasks":
				return "Learn more about the tasks involved";
			case "Withdrawing":
				return "Learn more about withdrawing";
		}
		return "Learn more";
	}

	VisualConsentStepManager.prototype.getVisualConsentImageUrl = function () {
		if (!this.currentVisualConsentSection) { return; }

		switch (this.currentVisualConsentSection.sectionType) {
			case "DataGathering":
				return ceUrl.make('content/researchkit/visualconsent/01_datagathering.png');
			case "Privacy":
				return ceUrl.make('content/researchkit/visualconsent/02_privacy.png');
			case "DataUse":
				return ceUrl.make('content/researchkit/visualconsent/03_datause.png');
			case "TimeCommitment":
				return ceUrl.make('content/researchkit/visualconsent/04_timecommitment.png');
			case "StudySurvey":
				return ceUrl.make('content/researchkit/visualconsent/05_studysurvey.png');
			case "StudyTasks":
				return ceUrl.make('content/researchkit/visualconsent/06_studytasks.png');
			case "Withdrawing":
				return ceUrl.make('content/researchkit/visualconsent/07_withdrawing.png');
		}
	}

	VisualConsentStepManager.prototype.isLastStep = function () {
		return StepManager.prototype.isLastStep.call(this) && (this.visualConsentStepIndex == this.totalVisualConsentSteps - 1);
	}

	VisualConsentStepManager.prototype.canGoBack = function () {
		return StepManager.prototype.canGoBack.call(this) || this.visualConsentStepIndex > 0;
	}

	VisualConsentStepManager.prototype.getCurrentFrameContent = function () {
		if (!this.currentVisualConsentSection) { return ""; }
		var styleblock = "<style type='text/css'> body { font-family: Helvetica, Arial; color:#333  } </style>";
		return styleblock + $sanitize(this.currentVisualConsentSection.htmlContent);
	}

	return VisualConsentStepManager;
}]);